var map = {
	"./Etelä-Saimaa.svg": 31,
	"./Helsingin-Sanomat.svg": 32,
	"./icons/clear.svg": 8,
	"./icons/email.svg": 9,
	"./icons/filter.svg": 6,
	"./icons/github.svg": 10,
	"./icons/info.svg": 33,
	"./icons/instagram.svg": 11,
	"./icons/linkedin.svg": 12,
	"./icons/linkedin_i.svg": 34,
	"./icons/snapchat.svg": 13,
	"./icons/snapchat_i.svg": 35,
	"./icons/sort.svg": 7,
	"./portfolio/720GreenCityBlock.mp4": 36,
	"./portfolio/AppDev.png": 37,
	"./portfolio/Club.jpg": 38,
	"./portfolio/GreenCityBlock.mp4": 39,
	"./portfolio/GreenCityBlock.png": 40,
	"./portfolio/Hack4OpenGLAM.png": 41,
	"./portfolio/Matikkaeditori.fi.png": 42,
	"./portfolio/OpenWilma.png": 43,
	"./portfolio/QR-pyörä.png": 44,
	"./portfolio/TikTok.png": 45,
	"./portfolio/WebKorjaamo.png": 46,
	"./portfolio/YTL.png": 47,
	"./portfolio/YritysHyvä.png": 48,
	"./portfolio/covid-19.fi.png": 49,
	"./portfolio/intia.jpg": 50,
	"./portfolio/keissifi.png": 51,
	"./portfolio/ruokalista.png": 52,
	"./portfolio/sammonlahdenak.com.png": 53,
	"./portfolio/testausserveri.jpeg": 54,
	"./tab.svg": 55,
	"./tivi.png": 56,
	"./white.png": 57
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30;